import { InternetAppProps } from "../../../Components/InternetApps/VaticanInternetApp/InternetApp";

import Header from "./VaticanInternetAssets/NewsLogo.webp";

export const VaticanInternetContent: InternetAppProps = {
  headerImage: Header,
  logoIcon: "",
  searchBarText: "Search romedailynews.co",
  introText: `Rome’s Chief of Police, Giorgio Corsi, is set to appear in court tomorrow at 12pm midday to appeal a nine-month driving ban imposed after he accrued multiple speeding fines.`,
  bodyText: `Corsi, who has served as the city’s top law enforcement officer since 2014, argues that the ban would severely hinder his ability to perform his duties, which he describes as a vital public service.

Corsi’s legal team will contend that the fines were issued for minor infractions, with the accused only marginally exceeding speed limits on each occasion. His lawyer, Marco Ferrara, stated, “There was no malicious intent or reckless behavior in these incidents.”

Ferrara emphasized that Corsi's preference for driving a Pica Uno, a compact car used by many ordinary Romans, shows he treats driving as a means to get from point A to point B, rather than an opportunity to showcase machismo or status.

The case has sparked debate among Romans, with some supporting Corsi’s appeal on the grounds of his essential role in public safety, while others argue that no individual, regardless of position, should be exempt from traffic laws.

The court’s decision, expected in the coming weeks, could set a precedent for how public officials are treated under Italy’s traffic regulations. For now, all eyes are on tomorrow’s hearing, where Corsi will make his case to retain his driving privileges.`,
  website: "romdailynews.co",
  photoCaption: "",
  articleTitle:
    "Rome Chief of Police Appeals Driving Ban Ahead of Court Appearance",
  articleDate: "Thursday Apr 17, 2025",
  author: "Written by Sofia Moretti",
};
